import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import { PageFade } from "@/components/LuxLoader";

// Full-app layout with a subtle fade + slide-up transition on every route
// change. The `key` on <PageFade> forces the animation to replay on nav.
const Layout = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-white text-black flex flex-col">
      {/* WCAG skip-to-content link — visible only on keyboard focus. */}
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">
        Skip to content
      </a>
      <main id="main-content" role="main" className="flex-1 pb-nav" tabIndex={-1}>
        <PageFade key={location.pathname}>
          <Outlet />
        </PageFade>
      </main>
      <BottomNav />
    </div>
  );
};

export default Layout;
